import { useEffect } from "react";

interface HubSpotWindow extends Window {
  _hsq?: any[];
}

export default function useHubspot() {
  useEffect(() => {
    const portalId = process.env.REACT_APP_HUBSPOT_PORTAL_ID;

    if (!portalId) return;

    // Initialize HubSpot tracking queue if it doesn't exist
    const hsWindow = window as HubSpotWindow;
    hsWindow._hsq = hsWindow._hsq || [];

    const script = document.createElement("script");
    script.src = `https://js.hs-scripts.com/${portalId}.js`;
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.id = "hs-script-loader";
    document.head.appendChild(script);

    return () => {
      document.getElementById("hs-script-loader")?.remove();
    };
  }, []);

  // Track user authentication events
  const trackSignUp = (email: string, additionalProperties?: Record<string, any>) => {
    const hsWindow = window as HubSpotWindow;
    if (!hsWindow._hsq) return;

    // Identify the user by email
    hsWindow._hsq.push([
      "identify",
      {
        email: email,
        ...additionalProperties
      }
    ]);

    // Track the sign up event
    hsWindow._hsq.push([
      "trackEvent",
      {
        id: "user_signed_up",
        value: additionalProperties?.accountType || "user"
      }
    ]);
  };

  const trackSignIn = (email: string, additionalProperties?: Record<string, any>) => {
    const hsWindow = window as HubSpotWindow;
    if (!hsWindow._hsq) return;

    // Identify the user by email
    hsWindow._hsq.push([
      "identify",
      {
        email: email,
        ...additionalProperties
      }
    ]);

    // Track the sign in event
    hsWindow._hsq.push([
      "trackEvent",
      {
        id: "user_signed_in"
      }
    ]);
  };

  const identifyUser = (email: string, properties?: Record<string, any>) => {
    const hsWindow = window as HubSpotWindow;
    if (!hsWindow._hsq) return;

    hsWindow._hsq.push([
      "identify",
      {
        email: email,
        ...properties
      }
    ]);
  };

  return {
    trackSignUp,
    trackSignIn,
    identifyUser
  };
}
